import * as exElement from '../../../utils/element';

// ----------------------------------------------------------------------------

function createTableWrapper(config: Record<string, any> = {}): HTMLElement {
    return exElement.create({
        merge: config,
        class: {
            add: 'table-wrapper',
        },
    });
}

// ----------------------------------------------------------------------------

export default createTableWrapper;
